import { useState, useEffect } from "react";
import { useToast } from "../hooks/useToast";

const useOpportunityModal = (towerList, setTowerInfo) => {
  const { addToast } = useToast();
  const [scopeOfWork, setScopeOfWork] = useState(null);
  // Initialize with create_new instead of no_tower
  const [selectedSerialNumber, setSelectedSerialNumber] = useState(null);
  const [modalState, setModalState] = useState({
    activeMainSection: "description",
  });

  useEffect(() => {
    if (towerList && towerList.length > 0) {
      const towerInfo = towerList[0];
      if (towerInfo.towerInfo?.generalTowerDescription?.serialNumber) {
        setSelectedSerialNumber(
          towerInfo.towerInfo.generalTowerDescription.serialNumber
        );
        setTowerInfo(towerInfo);
      } else {
        setSelectedSerialNumber("");
        setTowerInfo(null);
      }
    } else {
      setSelectedSerialNumber("");
      setTowerInfo(null);
    }
  }, [towerList, setTowerInfo]);

  const handleTabClick = async (sectionId) => {
    setModalState((prevState) => ({
      ...prevState,
      activeMainSection:
        prevState.activeMainSection === sectionId ? null : sectionId,
    }));

    if (sectionId === "scopeOfWork") {
      try {
        console.log("Questionnaires are now removed.");
      } catch (error) {
        console.error("Error fetching scope of work questionnaires:", error);
        addToast("Failed to fetch scope of work details", "danger");
      }
    }
  };

  return {
    scopeOfWork,
    selectedSerialNumber,
    setSelectedSerialNumber,
    modalState,
    handleTabClick,
  };
};

export default useOpportunityModal;
